exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachments[data-v-0877936c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.attachments button[data-v-0877936c]{padding-top:3px;padding-bottom:3px;margin-left:0;overflow:hidden;text-overflow:ellipsis;width:100%;text-align:left}", ""]);

// exports
